import axiosInstance from "../../lib/axiosInstance"

export const getPlanById = async(planId) => {
    const response = await axiosInstance(`/plans/${planId}`)
    return response?.data
}